export function getContributors() {
    return [
        {
            name: 'Vinzenz Rosenkranz',
            roles: ['development_lead', 'project_lead'],
        },
        {
            name: 'Benjamin Mitzkus',
            roles: ['development'],
        },
        {
            name: 'Dirk Seidensticker',
            roles: ['support_archaeology'],
        },
        {
            name: 'Benjamin Glissmann',
            roles: ['support_archaeology'],
        },
        {
            name: 'Michael Derntl',
            roles: ['support_development', 'support_database'],
        },
        {
            name: 'Matthias Lang',
            roles: ['support_archaeology', 'project_lead_former'],
        }
    ];
};
